import QRCode from "react-qr-code";
import React from "react";
import {SetupCode2FA} from "Stores/Auth/types";
import {Values} from "Tools/Values";
import {Loader, Enable2FAContentContainer} from "../../styles";
import {QRCodeContainer, ManualCode} from "./styles";

interface IProps {
    setup: SetupCode2FA
}

const Setup2FA = ({setup}: IProps) => {
    const formatManualCode = () => (
        setup.setupCode
            .replace(/(.{4})/g,"$1 ")
            .trim()
    );
    
    return (
        <Enable2FAContentContainer>
            <span>
                {Values.getLocalizationValue('openAuthAppToScanCode')}:
            </span>

            <QRCodeContainer>
                {setup.setupUrl !== '' ? (
                    <QRCode
                        value={setup.setupUrl}
                        size={256}
                        fgColor='#444444'
                    />
                ) : (
                    <Loader/>
                )}
            </QRCodeContainer>

            <span>
                {Values.getLocalizationValue('orEnterCodeManually')}:
            </span>

            <ManualCode value={formatManualCode()}/>
        </Enable2FAContentContainer>
    );
}

export default Setup2FA;
